import React, { Component, Fragment, createRef } from 'react';
import { connectAutoComplete } from 'react-instantsearch-dom';
import AutoSuggest from 'react-autosuggest';
import parse from 'html-react-parser';
import classnames from 'classnames';

import '../../sass/algolia-search/autocomplete.scss';

const getSuggestionValue = suggestion => {
    if (suggestion.title)
        return suggestion.title;

    if (suggestion.value)
        return suggestion.value;
};

class Autocomplete extends Component {

    state = {
        value: this.props.query,
        suggestions: [],
        selected: this.setSelectedStateFromProps(),
    };

    shouldSubmit = createRef();

    index = this.props.index;

    componentDidMount() {
        this.shouldSubmit.current = true;
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps.refinementList) !== JSON.stringify(this.props.refinementList)) {
            this.setState({
                selected: this.setSelectedStateFromProps()
            })
        }
    }

    setSelectedStateFromProps() {
        const selected = []
        for (const property in this.props.refinementList) {
            let type = property;
            this.props.refinementList[property].forEach(value => {
                selected.push({
                    value: value,
                    type: type
                })
            });
        }
        return selected;
    }

    onSuggestionHighlighted = ({ suggestion }) => {
        this.shouldSubmit.current = false;
    }

    getSuggestions(query) {
        let suggestions = [];

        const filterAndPush = (type, facetHits) => {
            // console.log(type, facetHits);
            // console.log(this.props.refinementList[type]);
            if (!!this.props.refinementList) {
                if (!this.props.refinementList[type]) {
                    suggestions.push({ title: type, suggestions: facetHits });
                } else {
                    let filteredHits = facetHits.filter(hit => {
                        return !this.props.refinementList[type].includes(hit.value)
                    });

                    suggestions.push({ title: type, suggestions: filteredHits });
                }
            } else {
                suggestions.push({ title: type, suggestions: facetHits });
            }
        }

        Promise.all([
            this.index.search(query, {
                attributesToRetrieve: ['title', 'slug', 'thumbnail'],
                hitsPerPage: 2,
                queryType: 'prefixAll',
            }),
            this.index.searchForFacetValues('categories', query, { maxFacetHits: 2, }),
            this.index.searchForFacetValues('permit', query, { maxFacetHits: 2, }),
            this.index.searchForFacetValues('city', query, { maxFacetHits: 2, }),
            this.index.searchForFacetValues('mediaTags', query, {
                maxFacetHits: 4,
            }),
        ]).then(results => {
            let type;
            let suggestionsFetched;
            if (!!results[4].facetHits && results[4].facetHits.length)
                suggestions.push({ title: "images", suggestions: results[4].facetHits, });
            if (results[0].hits.length)
                suggestions.push({ title: "locations", suggestions: results[0].hits, });

            filterAndPush('categories', results[1].facetHits);
            filterAndPush('permits', results[2].facetHits);
            filterAndPush('cities', results[3].facetHits);

            // suggestions.push({ title: 'test', suggestions: []});

            this.setState({ suggestions });
        });
    }

    onChange = (event, { newValue }) => {
        if (!newValue) {
            this.onSuggestionsClearRequested();
        }
        this.setState({ value: newValue });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.getSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    renderSuggestion = suggestion => {
        const className = "il-pill d-inline-block";
        if (!!suggestion._highlightResult && suggestion._highlightResult.title.value) {
            return (
                <span className={classnames(className, 'pr-3')}>
                    {suggestion.thumbnail && (
                        <img className="thumb object-fit" width="70" height="70" src={suggestion.thumbnail} />
                    )}
                    {parse(suggestion._highlightResult.title.value)}
                </span>
            )
        }

        if (suggestion.value) {
            return <span className={classnames(className, "px-2")}>
                {parse(suggestion.highlighted)}
            </span>
        }
    };

    render() {
        const { value, suggestions, shouldSubmit, highlightedSuggestion } = this.state;

        const inputProps = {
            className: !!this.props.className ? this.props.className : null,
            placeholder: "",
            autoFocus: !!this.props.autoFocus ? this.props.autoFocus : false,
            onChange: this.onChange,
            onKeyUp: !!this.props.onPressEnter ? e => {
                // if (!!this.shouldSubmit.current) {
                    if (e.keyCode === 13) {
                        this.props.onPressEnter(value, this.shouldSubmit.current);
                    }
                // }
            } : null,
            value,
        };

        const renderSectionTitle = (section) => {
            if (section.suggestions.length !== 0) {
                return (
                    <span className="d-flex flex-wrap">
                        <strong>{section.title}</strong>
                        {!!this.props.refinementList && !!this.props.refinementList[section.title]
                            && this.props.refinementList[section.title].map((value, key) =>
                                <span
                                    key={key}
                                    className="il-pill d-inline-block px-2 mx-1 bg-primary text-white small"
                                    style={{ opacity: .7 }}
                                >
                                    {value}
                                </span>
                            )}
                    </span>
                );
            }
        }

        function getSectionSuggestions(section) {
            if (!!section.suggestions) {
                return section.suggestions;
            }
            return null;
        }

        const onSuggestionSelected = (event, hit) => {

            let hitAlreadySelected = false;

            this.state.selected.forEach(item => {
                if (item.value === hit.suggestion.value && item.type === hit.suggestion.type) {
                    hitAlreadySelected = true;
                    return false;
                }
            });

            if (!hitAlreadySelected) {
                this.props.onSuggestionSelected(hit, suggestions[hit.sectionIndex]);

                if (suggestions[hit.sectionIndex].title !== 'locations'
                    && suggestions[hit.sectionIndex].title !== 'images') {
                    const selected = [...this.state.selected];
                    selected.push({
                        value: hit.suggestion.value,
                        type: suggestions[hit.sectionIndex].title,
                    });
                    this.setState({
                        value: '',
                        selected: selected,
                    });
                }
            }
        }

        const submitSearch = () => {
            window.location.href = `${window.location.origin}/search?query=${encodeURIComponent(this.state.value)}`;
        }

        let geoSectionTitles = [
            'cities'
        ];

        return (
            <Fragment>
                <AutoSuggest
                    alwaysRenderSuggestions={false}
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={onSuggestionSelected}
                    getSuggestionValue={getSuggestionValue}
                    onSuggestionHighlighted={this.onSuggestionHighlighted}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    multiSection={true}
                    renderSectionTitle={renderSectionTitle}
                    getSectionSuggestions={getSectionSuggestions}
                    renderSuggestionsContainer={({ containerProps, children, query }) => {

                        let sections = [];
                        let geoSections = [];
                        !!children && children.forEach((child, key) => {
                            if (child.props.children[0].props.section.suggestions.length) {
                                if (geoSectionTitles.includes(child.props.children[0].props.section.title)) {
                                    geoSections.push(
                                        <div key={key} className={`il-section il-section-${child.props.children[0].props.section.title}`}>
                                            {child}
                                        </div>
                                    );
                                } else {
                                    sections.push(
                                        <div key={key} className={`il-section il-section-${child.props.children[0].props.section.title}`}>
                                            {child}
                                        </div>
                                    );
                                }
                            }
                        })

                        return (
                            <div {...containerProps}>
                                <div className="il-autosuggest-inner d-flex flex-wrap">
                                    {sections}
                                    <div className="geo-section d-flex">
                                        {geoSections}
                                    </div>
                                </div>
                                {/* {this.props.addSubmitButton && !!this.state.suggestions.length && (
                                    <div className="w-100 text-center">
                                        <button
                                            onClick={submitSearch}
                                            className="btn btn-link btn-sm text-dark"
                                        >View More Results</button>
                                    </div>
                                )} */}
                            </div>
                        );
                    }}
                    shouldRenderSuggestions={() => {
                        return true;
                        // if (this.state.value == "") {
                        //     return false;
                        // } else {
                        //     return this.shouldRender;
                        // }
                    }}
                />

                {!!this.props.addSubmitButton && (
                    <div className="input-group-append">
                        <button
                            onClick={submitSearch}
                            className="btn bg-primary text-white rounded-0" id="auto-compleset-search-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="mt-n1 search-icon"> <path fill="currentColor" d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"></path></svg></button>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default connectAutoComplete(Autocomplete);
